import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface CarePlanFiltersState {
  status: string[];
  intent: string[];
}

const initialState: CarePlanFiltersState = {
  status: [],
  intent: [],
};

const slice = createSlice({
  name: "carePlanFilters",
  initialState,
  reducers: {
    setCarePlanFilters(
      state: CarePlanFiltersState,
      action: PayloadAction<Partial<CarePlanFiltersState>>,
    ): void {
      Object.assign(state, action.payload);
    },
    updateCarePlanFilter(
      state: CarePlanFiltersState,
      action: PayloadAction<{ key: string; value: any }>,
    ): void {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    resetCarePlanFilters(state: CarePlanFiltersState): void {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setCarePlanFilters,
  updateCarePlanFilter,
  resetCarePlanFilters,
} = slice.actions;
export const { reducer } = slice;

export default slice;
